import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FilterChipPill } from './FilterChipPill';
import type { FilterChip } from './filters';
import { ROSTER } from './tokens';

type Props = {
  chips: FilterChip[];
  onRemove: (index: number) => void;
  onClearAll: () => void;
  onAdd: (anchor: HTMLElement) => void;
  onEdit: (index: number, anchor: HTMLElement) => void;
};

export function FilterBar({ chips, onRemove, onClearAll, onAdd, onEdit }: Props) {
  return (
    <Box
      data-testid="filter-bar"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
        overflow: 'visible',
      }}
    >
      {chips.length > 0 && (
        <Box
          component="span"
          sx={{
            fontFamily: ROSTER.font,
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: ROSTER.muted,
            mr: '2px',
          }}
        >
          Filters
        </Box>
      )}
      {chips.map((chip, index) => (
        <FilterChipPill
          key={index}
          chip={chip}
          onRemove={() => onRemove(index)}
          onEdit={(anchor) => onEdit(index, anchor)}
        />
      ))}
      <Box
        component="button"
        type="button"
        data-testid="filter-add"
        onClick={(event: React.MouseEvent<HTMLElement>) => onAdd(event.currentTarget)}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          p: '7px 13px',
          borderRadius: '999px',
          border: (theme) => `1px dashed ${alpha(theme.palette.primary.main, 0.45)}`,
          background: 'transparent',
          fontFamily: ROSTER.font,
          fontSize: 12,
          fontWeight: 700,
          color: (theme) => theme.palette.primary.main,
          cursor: 'pointer',
        }}
      >
        + Add filter
      </Box>
      {chips.length > 0 && (
        <Box
          component="button"
          type="button"
          data-testid="filter-clear-all"
          onClick={onClearAll}
          sx={{
            ml: 'auto',
            background: 'none',
            border: 0,
            fontFamily: ROSTER.font,
            fontSize: 12,
            fontWeight: 600,
            color: ROSTER.muted,
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Clear all
        </Box>
      )}
    </Box>
  );
}
